import Vue from 'vue'
import VueResource from 'vue-resource'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import appConfig from '@/config.js'
import vueAuthInstance from '@/services/auth'
import store from '@/store/index'
import NProgress from 'nprogress'

Vue.use(VueResource)
Vue.use(Router)

// Auth
import OauthRedirect from '@/pages/oauth_redirect'
import LoginPage from '@/pages/login'
import RegisterPage from '@/pages/register_company'
import PwdResetEmailPage from '@/pages/password_email'
import PwdResetPage from '@/pages/password_reset'

// Panels
// import ShippingsSummary from '@/pages/summary'
// import ControlPanel from '@/pages/control_panel'
import IncidencesPanel from '@/pages/incidences_panel'
import DeliveryDateMonitor from '@/pages/delivery_date_monitor'

// Map
// import Map from '@/pages/map'

// Users
import UsersList from '@/components/Users/List'
import UsersEdit from '@/components/Users/Edit'

// Companies
import CompaniesList from '@/pages/company_list'
import CompaniesCreate from '@/pages/company_create'
import CompaniesEdit from '@/pages/company_edit'

// Carriers
import CarriersList from '@/components/Companies/CarrierList'
import CarriersEdit from '@/components/Companies/CarrierEdit'

// Customers
import CustomersList from '@/components/Companies/CustomerList'
import CustomersEdit from '@/components/Companies/CustomerEdit'

// Tours
import ToursList from '@/components/Tours/List'
import ToursEdit from '@/components/Tours/Edit'

// Shippings
import ShippingsList from '@/components/Shippings/List'
// import ShippingsEdit from '@/components/Shippings/Edit'
import ShippingsCreate from '@/components/Shippings/Create'
import ShippingsBulkImport from '@/components/Shippings/BulkImport'

// Integrations
import ShippingTaskHooksList from '@/components/Integrations/ListTaskHooks'

// Shipping Files
import OcrControl from '@/components/ShippingFiles/OcrList'

// Items
import ItemsList from '@/components/Items/List'
import ItemsShippingHistory from '@/components/Items/ShippingHistory'

// Geofences
import GeofencesList from '@/components/Geofences/List'
import GeofencesEdit from '@/components/Geofences/Edit'

// ShippingOrders
import ShippingOrdersList from '@/components/ShippingOrders/List'
import ShippingOrdersEdit from '@/components/ShippingOrders/Edit'

// Configs
import TransactionsHistory from '@/pages/transactions_history'
import ConfigGeneral from '@/components/ConfigGeneral'
import ConfigCommissions from '@/components/ConfigCommissions'
import ConfigVehicles from '@/components/Vehicles/List'
import StoresManagement from '@/pages/company_stores_management'

// Generic
import ApiList from '@/components/ApiLists/ApiList'
import ApiItemEdit from '@/components/ApiLists/ApiItemEdit'

// Misc
import ProductDistributorPage from '@/pages/distributor_page'
import ProductDistributorComponent from '@/components/ProductDistributor'
import DownloadFromApi from '@/pages/download_from_api'
import DummyPage from '@/pages/dummy'

// Error 404
import ErrorPage from '@/pages/error'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/', redirect: '/summary'
    },
    // Auth
    {
      path: '/oauth',
      name: 'oauth',
      component: OauthRedirect,
      meta: {
        auth: false,
        title: 'OAuth Redirect',
        layout: 'auth'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: {
        auth: false,
        title: 'Log in to your account',
        layout: 'auth'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: RegisterPage,
      meta: {
        auth: false,
        title: 'Sign up for new account',
        layout: 'auth'
      }
    },
    {
      path: '/password/reset',
      name: 'password_email',
      component: PwdResetEmailPage,
      meta: {
        auth: false,
        title: 'Forgot Password',
        layout: 'auth'
      }
    },
    {
      name: 'password_reset',
      path: '/password/reset/:token',
      component: PwdResetPage,
      props: true,
      meta: {
        auth: false,
        title: 'Reset Password',
        layout: 'auth'
      }
    },
    // Panels
    {
      path: '/summary',
      name: 'shippingsSummary',
      component: ProductDistributorPage,
      meta: {
        auth: true,
        title: 'Summary',
        name: 'summary',
        dontReuse: true
      }
    },
    {
      path: '/control',
      name: 'controlPanel',
      component: ProductDistributorPage,
      meta: {
        auth: true,
        title: 'Control',
        name: 'control_panel',
        dontReuse: true
      }
    },
    {
      path: '/incidences',
      name: 'incidencesPanel',
      component: IncidencesPanel,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    {
      path: '/delivery-date-monitor',
      name: 'DeliveryDateMonitor',
      component: DeliveryDateMonitor,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    // Map
    {
      path: '/map/',
      name: 'map',
      component: ProductDistributorPage,
      meta: {
        auth: true,
        title: 'Map',
        layout: 'full-map',
        name: 'map',
        dontReuse: true
      }
    },
    // Users
    {
      path: '/users/list',
      name: 'UsersList',
      component: UsersList,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    {
      path: '/users/edit/:id',
      name: 'UsersEdit',
      component: UsersEdit,
      meta: {
        auth: true,
        title: 'Edit'
      },
      props: true
    },
    // Companies
    {
      path: '/companies/list',
      name: 'CompaniesList',
      component: CompaniesList,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    {
      path: '/companies/new',
      name: 'CompaniesCreate',
      component: CompaniesCreate,
      meta: {
        auth: true,
        title: 'Create'
      }
    },
    {
      path: '/companies/edit/:id',
      name: 'CompaniesEdit',
      component: CompaniesEdit,
      meta: {
        auth: true,
        title: 'Edit'
      },
      props: true
    },
    // Carriers
    {
      path: '/carriers/list',
      name: 'CarriersList',
      component: CarriersList,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    {
      path: '/carriers/new',
      name: 'CarriersCreate',
      component: CarriersEdit,
      meta: {
        auth: true,
        title: 'Create'
      }
    },
    {
      path: '/carriers/edit/:id',
      name: 'CarriersEdit',
      component: CarriersEdit,
      meta: {
        auth: true,
        title: 'Edit'
      },
      props: true
    },
    // Customers
    {
      path: '/customers/list',
      name: 'CustomersList',
      component: CustomersList,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    {
      path: '/customers/new',
      name: 'CustomersCreate',
      component: CustomersEdit,
      meta: {
        auth: true,
        title: 'Create'
      }
    },
    {
      path: '/customers/edit/:id',
      name: 'CustomersEdit',
      component: CustomersEdit,
      meta: {
        auth: true,
        title: 'Edit'
      },
      props: true
    },
    // Tours
    {
      path: '/tours/list',
      name: 'tourList',
      component: ToursList,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    {
      path: '/tours/edit/:id',
      name: 'ToursEdit',
      component: ToursEdit,
      meta: {
        auth: true,
        title: 'Edit'
      },
      props: true
    },
    // Shippings
    {
      path: '/shippings/list',
      name: 'ShippingsList',
      component: ShippingsList,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    {
      path: '/shippings/edit/:id',
      name: 'ShippingsEdit',
      component: ProductDistributorComponent,
      meta: {
        auth: true,
        title: 'Edit',
        entity: 'Shippings',
        action: 'Edit'
      },
      props: true
    },
    {
      path: '/shippings/new',
      name: 'ShippingsCreate',
      component: ShippingsCreate,
      meta: {
        auth: true,
        title: 'Create',
        layout: 'full-map'
      },
      props: true
    },
    {
      path: '/shippings/bulk-import',
      name: 'ShippingsBulkImport',
      component: ShippingsBulkImport,
      meta: {
        auth: true,
        title: 'Create'
      },
      props: true
    },
    // Integrations
    {
      path: '/shipping-tasks-hooks/list',
      name: 'ShippingTaskHooksList',
      component: ShippingTaskHooksList,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    // Shipping Files
    {
      path: '/ocr-control',
      name: 'OcrControl',
      component: OcrControl,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    // Items
    {
      path: '/items/list',
      name: 'ItemsList',
      component: ItemsList,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    {
      path: '/items/shipping-history',
      name: 'ItemsShippingHistory',
      component: ItemsShippingHistory,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    // Geofences
    {
      path: '/geofences/list',
      name: 'GeofencesList',
      component: GeofencesList,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    {
      path: '/geofences/edit/:id',
      name: 'GeofencesEdit',
      component: GeofencesEdit,
      meta: {
        auth: true,
        title: 'Edit'
      },
      props: true
    },
    {
      path: '/geofences/new',
      name: 'GeofencesCreate',
      component: GeofencesEdit,
      meta: {
        auth: true,
        title: 'Create'
      }
    },
    // Shipping Orders
    {
      path: '/shipping-orders/list',
      name: 'ShippingOrdersList',
      component: ShippingOrdersList,
      meta: {
        auth: true,
        title: 'List'
      }
    },
    {
      path: '/shipping-orders/edit/:id',
      name: 'ShippingOrdersEdit',
      component: ShippingOrdersEdit,
      meta: {
        auth: true,
        title: 'Edit'
      },
      props: true
    },
    {
      path: '/shipping-orders/clone/:cloneId',
      name: 'ShippingOrdersClone',
      component: ShippingOrdersEdit,
      meta: {
        auth: true,
        title: 'Edit'
      },
      props: true
    },
    {
      path: '/shipping-orders/new',
      name: 'ShippingOrdersCreate',
      component: ShippingOrdersEdit,
      meta: {
        auth: true,
        title: 'Create'
      }
    },
    // Configs
    {
      path: '/config/general',
      name: 'configGeneral',
      component: ConfigGeneral,
      meta: {
        auth: true,
        title: 'New'
      }
    },
    {
      path: '/transactions-history',
      name: 'TransactionsHistory',
      component: TransactionsHistory,
      meta: {
        auth: true,
        title: 'New'
      }
    },
    {
      path: '/config/commissions',
      name: 'configCommissions',
      component: ConfigCommissions,
      meta: {
        auth: true,
        title: 'New'
      }
    },
    {
      path: '/vehicles/list',
      name: 'configVehicles',
      component: ConfigVehicles,
      meta: {
        auth: true,
        title: 'New'
      }
    },
    {
      path: '/config/stores',
      name: 'StoresManagement',
      component: StoresManagement,
      meta: {
        auth: true,
        title: 'New'
      }
    },
    // Generic
    {
      path: '/:type/list',
      name: 'ApiList',
      component: ApiList,
      meta: { auth: true, title: 'List' },
      props: true
    },
    {
      path: '/:type/new',
      name: 'ApiItemEdit',
      component: ApiItemEdit,
      meta: { auth: true, title: 'Create' },
      props: true
    },
    // Misc
    {
      path: '/download/:url',
      name: 'downloadFromApiUrl',
      component: DownloadFromApi,
      meta: { auth: true, title: 'Download' },
      props: true
    },
    {
      path: '/download/:url/:badLinkPart2/:badLinkPart3',
      name: 'downloadFromApiUrlRedirect',
      component: DownloadFromApi,
      meta: { auth: true, title: 'Download' },
      props: true
    },
    {
      path: '/download',
      name: 'downloadFromApiQuerystring',
      component: DownloadFromApi,
      meta: { auth: true, title: 'Download' }
    },
    {
      path: '/quick-search',
      name: 'QuickSearch',
      component: () => import('../pages/quick_search.vue'),
      meta: {
        auth: true,
        title: 'Quick Search'
      },
      props: {
        type: 'search'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: DummyPage,
      meta: {
        auth: true,
        title: 'Search',
        layout: 'full-map'
      },
      props: {
        type: 'search'
      }
    },
    // Error 404
    {
      path: '*',
      name: '404',
      component: ErrorPage,
      meta: {
        auth: false,
        title: 'Error 404',
        layout: 'auth'
      }
    }
  ]
})

// loadBar start
router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
    NProgress.set(0.1)
    NProgress.set(0.4)
  }
  if (to.meta.layout === 'auth') {
    console.log('ñlksdñgflkjwtrelkwjerlkwrjlwekrjwer', to)
    store.commit('configComplete', true)
    // store.commit('resetConfigCount')
  }
  next()
})
// loadBar end
router.afterEach((to, from) => {
  setTimeout(() => NProgress.done(), 500)
})

router.beforeEach(async function (to, from, next) {
  const isDocumentation = new URL(window.location.origin).port === '6060'
  if (!isDocumentation && to.meta?.auth) {
    if (vueAuthInstance.isAuthenticated()) {
      store.commit('isAuthenticated', {
        isAuthenticated: vueAuthInstance.isAuthenticated()
      })
      if (!store.getters.uid) {
        const uid = vueAuthInstance.getPayload() ? vueAuthInstance.getPayload()['sub'] : null
        store.commit('setUid', uid)
      }
      if (!store.getters.profile?.id) {
        await store.dispatch('fetchProfile')
      }
      store.dispatch('checkAccessRules')
        .then(async result => {
          if (!result) {
            console.log('NOT ALLOWED')
            await store.dispatch('logout')
            router.push({ name: 'login', query: {redirect: to.fullPath, error: 'no-permission'} })
            return false
          }
        })

      if (!store.getters.ecosystemModules.remote) {
        await store.dispatch('setEcosystemModules', store.getters.eid)
      }
      next()
    } else {
      store.commit('setUid', null)
      store.commit('setProfile', {})
      router.push({ name: 'login', query: {redirect: to.fullPath} })
    }
  } else {
    next()
  }
})

if (appConfig.GA_ACCOUNT) {
  Vue.use(VueAnalytics, {
    id: appConfig.GA_ACCOUNT,
    router
  })
}

export default router
